import { Map } from "ol";
import { Coordinate } from "ol/coordinate";

export interface MapPositionStorage {
  center: Coordinate;
  zoom: number;
}

export function saveMapPosition(map: Map): void {
  const v = map.getView();
  const zoom = v.getZoom();
  const center = v.getCenter();
  if (!zoom || !center) return;
  const mapPosition = {
    center,
    zoom,
  };
  const positionToSave = JSON.stringify(mapPosition);
  sessionStorage.setItem("mapPosition", positionToSave);
}

export function readMapPosition(): MapPositionStorage | null {
  const storedPosition = sessionStorage.getItem("mapPosition");
  if (storedPosition) {
    const storedPos = JSON.parse(storedPosition) as MapPositionStorage;
    return storedPos;
  }
  return null;
}
